<template><div><p>404 Not Found</p>
</div></template>
<script>
export const _pageData = JSON.parse("{\"path\":\"/404.html\",\"title\":\"\",\"lang\":\"en-US\",\"frontmatter\":{\"layout\":\"NotFound\"},\"git\":{},\"filePathRelative\":null}")
export default { name: "404.html.vue" }
</script>